import "core-js/stable"
import "regenerator-runtime/runtime"
import React from 'react'
import PropTypes from "prop-types"
import styles from "./Radio.scss"

const propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  elements: PropTypes.array.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  setState: PropTypes.func,
  required: PropTypes.bool,
}

const defaultProps = {
  className: "",
  setState: null,
  onClick: null,
  onChange: null,
  setState: null,
  required: false,
}

const Radio = (props) => {
  let list = []
  props.elements.forEach((element, index) => {
    const elementId = `${props.id}_${element.value}`
    list.push(
      <div key={index}>
        <input
          type="radio"
          id={elementId}
          name={props.name}
          value={element.value}
          defaultChecked={element.value === props.value}
          onClick={element.onClick}
          onChange={(e) => {
            props.onChange && props.onChange(e)
            element.onChange && element.onChange(e)
          }}
          onInput={(e) => props.setState ? props.setState(e.target.value) : null}
          required={element.required}
        />
        <label htmlFor={elementId}>{element.label}</label>
      </div>
    )
  })

  // 初期値の表示は調整中(まだ正常に動作するかの検証ができてない)
  return (
    <div className={props.className}>
      <label>{props.label}</label>
      <div className={styles.radio}>
        {list}
      </div>
    </div>
  )
}

Radio.propTypes = propTypes
Radio.defaultProps = defaultProps

export default Radio
